__webpack_require__.p = "/ps-lounge/";